<template>
  <div :class="['filter-container flex-row', dbOptionHeight]">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <ms-validate ref="validateObserver">
          <menu-wrapper>
            <template #menu-button="{toggleMenu}">
              <button tabindex="-1" @click="toggleMenu" :class="['btn-filter-operator', dbOptionHeight]">
                <div :class="['icon20', nativeFilterIconClass]" :title="tooltipIcon"></div>
              </button>
            </template>
            <template #menu-content>
              <template v-for="(item, i) in filterOperators" :key="i">
                <menu-item
                  class="filter-operator-item"
                  :class="item.enumValue === operatorValue ? 'active' : ''"
                  @menu-item-click="filterOperatorItemClick(item)"
                  :icon="['icon24', item.icon]"
                  >{{ item?.enumText }}</menu-item
                >
              </template>
            </template>
          </menu-wrapper>
        </ms-validate>
      </ms-validate>
    </div>
    <div class="filter-value flex">
      <ms-combobox
        v-model="filterValue"
        :displayField="propsData.suffixDisplayField ? propsData.displayField : col.displayField ?? col.dataField"
        :valueField="propsData.suffixDisplayField ? propsData.valueField : col.dataField"
        :suffixDisplayField="propsData.suffixDisplayField"
        v-model:display="displaySuffixValue"
        ref="thEnum"
        :hasValidateControl="col.hasValidateControl"
        :forceReload="!col.disForceReload"
        :remoteFilter="filterMode == 'remote'"
        :filterGridLocal="filterMode != 'remote'"
        class="ms-input-filter-value"
        :title="col.tooltip || col.title || col.definition || col.caption"
        :isShowText="false"
        :data="col.filterValue"
        :columns="filterMode == 'remote' ? propsData.columns : []"
        :dropdownWidth="filterMode == 'remote' ? propsData.dropdownWidth : null"
        :formatType="col.formatType"
        :queryMode="col.filterMode || filterMode"
        :forceSelection="false"
        :toggleReset="resetToggle"
        @selected="
          ({newData}) => {customFilterHeaderHandle({
              operator: operatorValue,
              value: newData ? (propsData.suffixDisplayField ? displaySuffixValue : newData[col.dataField]) : newData,
            })
          }
        "
        @comboboxLoadData="
          payload => {
            searchData({operator: operatorValue, value: thEnum.internalText});
            onComboboxLoadData(payload, null, {
              dataField: col.dataField,
              sender: thEnum,
            });
          }
        "
        @comboboxLoadDataLocal="
          payload => {
            searchData({operator: operatorValue, value: thEnum.internalText});
            onComboboxLoadData(payload, null, {
              dataField: col.dataField,
              sender: thEnum,
            });
          }
        "
        @keydown.stop=""
        :hasBorder="false"
        :isGridEditor="isGridEditor"
        @handleScrollEndLocal="handleScrollEndLocal"
        @beforeExpandClick="beforeExpandClick"
        @onHandleInputText="onHandleInputText"
      ></ms-combobox>
    </div>
  </div>
</template>
<script>
import {computed, defineComponent, getCurrentInstance, ref, watch} from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import msValidate from '@/components/validate/MsValidate.vue';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
export default defineComponent({
  extends: msThOptionBase,
  components: {msValidate, MenuItem, MenuWrapper},
  name: 'MsThOptionCombobox',
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-contain',
    },
    propsData: {
      default: {},
      type: Object,
    },
    isGridEditor: {
      default: false,
      type: Boolean,
    },
    dbOptionHeight: {
      type: String,
    },
    /**
     * Biến xác định filter combo như nào
     * Dùng luôn giá trị giống querymode của grid.
     * Vì về cơ bản thì nếu grid đã query local thì thường filter cũng local
     * nvtoan2 13/09/2023
     */
    filterMode: {
      type: String,
      default: 'remote',
    },
  },
  // watch: {
  //   col: {
  //     handler(newVal, oldVal) {
  //       if (newVal?.resetFilter != oldVal?.resetFilter) {
  //         this.displaySuffixValue = '';
  //         this.filterValue = '';
  //         this.resetToggle = !this.resetToggle;
  //       }
  //     },
  //     deep: true,
  //     immediate: true,
  //   }
  // },
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    /**
     * Giá trị hiển thị của filter
     * NXCHIEN 30.05.2023
     */
    const displaySuffixValue = ref();

    /**
     * Tạo ra biến này để đánh dấu clear hết filter đi
     * Đang phục vụ cho grid bảng kê
     * nvtoan2 21/09/2023
     */
    const resetToggle = ref(false);

    //Khai báo data variable
    const {
      nativeFilterIconClass,
      tooltipIcon,
      operatorValue,
      filterValue,
      filterOperators,
      filterHeaderHandle,
      filterOperatorItemClick,
      removeFilter,
      thEnum,
    } = setup(props, {
      emit,
    });

    /**
     * Xóa Timeout
     * lttuan1
     */
    const customFilterHeaderHandle = ({operator: operatorValue, value: filterValue}) => {
      clearTimeout(proxy.timeOut);
      filterHeaderHandle({operator: operatorValue, value: filterValue});
    };
    //Method
    /**
     * Search dữ liệu khi nhập sau 1s
     * dqvinh 9.5.2023
     */
    const searchData = ({operator: operatorValue, value: filterValue}) => {
      clearTimeout(proxy.timeOut);
      proxy.timeOut = setTimeout(() => {
        proxy.filterValue = filterValue;
        if (!filterValue?.trim()?.length > 0) {
          filterValue = null;
        } else {
          switch (proxy.col.formatType) {
            case proxy.$ms.constant.FormatType.ComboboxAmount:
              filterValue = filterValue?.replaceAll('.', '')?.replaceAll(',', '');
              break;
          }
          filterHeaderHandle({operator: operatorValue, value: filterValue});
        }
      }, 1000);
    };

    /**
     * Băn sự kiện loadData ra bên ngoài để gọi API
     * dqvinh 23.05.2023.
     */
    const onComboboxLoadData = (payload, row, dataField) => {
      if (payload?.filter) {
        let fil = JSON.parse(payload.filter);
        if (fil?.length > 0) {
          fil[0].Field = dataField.dataField;
          fil[0].Operator = '*'; // Load combo thì luôn luôn bắn ra là chứa
          switch (proxy.col.formatType) {
            case proxy.$ms.constant.FormatType.ComboboxAmount:
              fil[0].Value = fil[0].Value?.replaceAll('.', '')?.replaceAll(',', '');
              break;
          }
          payload.filter = JSON.stringify(fil);
        }
      }
      emit('load-filter-header', payload, row, dataField);
    };

    /**
     * Bắn sự kiện scroll local
     */
    const handleScrollEndLocal = () => {
      emit('scroll-end-combobox-local');
    }
    /**
     * Bắn sự kiện xổ combo
     */
    const beforeExpandClick = () => {
      emit('before-expand-click');
    }
    /**
     * Bắn sự kiện input combo
     */
    const onHandleInputText = (value) => {
      emit('handle-input-text', value);
    }

    //Hooks
    return {
      nativeFilterIconClass,
      filterValue,
      operatorValue,
      filterOperators,
      filterOperatorItemClick,
      filterHeaderHandle,
      removeFilter,
      thEnum,
      searchData,
      onComboboxLoadData,
      displaySuffixValue,
      resetToggle,
      customFilterHeaderHandle,
      handleScrollEndLocal,
      beforeExpandClick,
      onHandleInputText,
      tooltipIcon,
    };
  },
});
</script>
